import React from 'react';
import RegisterForm from './RegisterForm';
import { CheckAuthInLoginPage } from 'src/utils/checkAuth.utils';

const Login = () => {
    const isAuth = CheckAuthInLoginPage();
    if (isAuth === undefined) return null;
    return (
        <div className="login-wrap tw-h-screen">
            <RegisterForm />
        </div>
    );
};

export default Login;
